import { Component, Input } from '@angular/core';
import { AbstractBreezeListComponent } from '@common/classes/breeze-list';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-chat-note-modal',
    templateUrl: './chat-note-modal.component.html',
    styleUrls: ['./chat-note-modal.component.scss'],
    providers: [BreezeViewService]
})
export class ChatNoteModalComponent extends AbstractBreezeListComponent {
    queryName = 'ChatNotes';
    persistFilter = false;
    notes = [];
    newNote = null;
    isSeen: boolean;

    @Input() parentNote: any;
    @Input() vesselNotificationId: number;

    constructor(protected breezeViewService: BreezeViewService, public activeModal: NgbActiveModal) {
        super(breezeViewService);
    }

    override search() {
        // this.isBusy = true;
        if (!this.parentNote) return;

        this.filter.parentChatNoteId = this.parentNote?.id;
        this.filter.vesselNotificationId = this.vesselNotificationId;
        const query = this.getQuery();
        this.entityManager.executeQuery(query).then((response) => {
            this.isBusy = false;
            this.notes = response.results;
        });
        return query;
    }

    getNoteStyle(note, isCard: boolean, isAttachment: boolean = false) {
        const isFromCurrentUser = note.createdById === this.user?.id;
        return isCard ? isAttachment ? { 'float': isFromCurrentUser ? 'left' : 'right' }
            : { 'float': isFromCurrentUser ? 'right' : 'left' }
            : { 'background-color': isFromCurrentUser ? '#5BBAD5' : '#888', };
    }

    saveNewNote() {
        this.newNote.parentChatNoteId = this.parentNote?.id;
        this.breezeViewService.handleCommand('SaveChatNote', this.newNote).then((savedNote) => {
            this.parentNote ||= savedNote;
            this.search();
            this.newNote = null;
        });
    }

    addNewNote() {
        this.newNote = { vesselNotificationId: this.vesselNotificationId };
        setTimeout(() => {
            const modalBody = document.getElementsByClassName('modal-body')[0];
            modalBody.scrollTop = modalBody.scrollHeight; // Scroll to bottom
        });
    }

    close() {
        this.isSeen = this.notes.every(note => note.seenByUsers.some(x => x.userId === this.user.id));
        this.activeModal.close({ isSeen: this.isSeen });
    }
}
